import React from "react";
import { StyledMainBox } from "../../../../components/commonComponents/StyledComponents/styled";
import AccessControl from "../../../../components/commonComponents/Hoc/AccessControl";
import { useDispatch, useSelector } from "react-redux";
import AnalyticsDashboard from "../../Reports/AnalyticsDashboard";
import { fetchCampaign } from "../../../../api_calls/campaignRequests";
import { checkUserRole } from "../../../../api_calls/userManagement";
import { fetchReportTabsConfig } from "../../../../api_calls/ReportSettings";

const ReportLayout = ({ campaignId }) => {
    const currentStateData = useSelector((state) => state.userSelections);

    const tabsConfig = fetchReportTabsConfig();

    const userRole = checkUserRole();

    React.useEffect(() => {
        // fetchCampaign(campaignId, "all", userRole.user_role, "preview");
    }, []);

    return (
        <StyledMainBox component="main" sx={{ padding: "10px 13px" }}>
            {typeof currentStateData.campaign_detail !== "undefined" && typeof currentStateData.brand_filters !== "undefined" && tabsConfig.length !== 0 &&
                <AnalyticsDashboard
                    reportSettingArr={tabsConfig}
                    viewMode={userRole.user_role}
                    preview={true}
                />
            }
        </StyledMainBox>
    );
};

export default AccessControl(ReportLayout, [
    "campaign_reports_performance_can_view",
    "campaign_reports_impression_can_view",
], [], ["campaigns_section", "campaign_list"], "preview");
